import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getOrCreateGlobalContext, CONTEXT_NAMES } from '../globalContexts';
import { Themes } from './consts';
import objectValues from '../objectValues';

const defaultContextValue = { theme: Themes.MATRIX };

const ThemeContext = getOrCreateGlobalContext(CONTEXT_NAMES.Theme);

const ThemeProvider = ({ theme, children }) => (
  <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
);

ThemeProvider.Themes = Themes;

ThemeProvider.defaultProps = { theme: defaultContextValue.theme };

ThemeProvider.propTypes = {
  theme: PropTypes.oneOf(objectValues(Themes)),
  children: PropTypes.node.isRequired
};

const useTheme = () => {
  const contextValue = useContext(ThemeContext);
  return contextValue || defaultContextValue;
};

const ThemeConsumer = ({ children }) => (
  <ThemeContext.Consumer>
    {contextValue => children(contextValue || defaultContextValue)}
  </ThemeContext.Consumer>
);

ThemeConsumer.propTypes = {
  children: PropTypes.func.isRequired
};

export default ThemeContext;

export { Themes, ThemeConsumer, useTheme, ThemeProvider };
